import React, {Component} from "react"
import {Row, Grid} from "react-bootstrap"

import withBranding, {WithBranding} from "@irati/brand/withBranding"

import {SideBar, MainSection} from "../components/UserOnboarding"
import {BackGround, Col} from "./styled"

interface Props extends WithBranding {}

class OnboardContainer extends Component<Props> {
  render() {
    const color = this.props.branding.primaryColour
    const maxHeight = {height: "100%"}

    return (
      <BackGround color={color}>
        <Grid style={maxHeight}>
          <Row style={maxHeight}>
            <Col md={7} style={maxHeight}>
              <MainSection>{this.props.children}</MainSection>
            </Col>
            <Col smHidden xsHidden>
              <SideBar />
            </Col>
          </Row>
        </Grid>
      </BackGround>
    )
  }
}

export default withBranding(OnboardContainer)
